import React, { useEffect, useState } from "react";
import Header from "../Section/Header";
import Footer from "../Section/Footer";
import DOMPurify from "dompurify";
import {
  get_daily_prediction,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Section/Loader";
export default function DailyPrediction() {
  const zodiacList = [
    { symbol: "♈", name: "Aries", date: "", element: "Fire" },
    { symbol: "♉", name: "Taurus", date: "", element: "Earth" },
    { symbol: "♊", name: "Gemini", date: "", element: "Air" },
    { symbol: "♋", name: "Cancer", date: "", element: "Water" },
    { symbol: "♌", name: "Leo", date: "", element: "Fire" },
    { symbol: "♍", name: "Virgo", date: "", element: "Earth" },
    { symbol: "♎", name: "Libra", date: "", element: "Air" },
    {
      symbol: "♏",
      name: "Scorpio",
      date: "",
      element: "Water",
    },
    {
      symbol: "♐",
      name: "Sagittarius",
      date: "",
      element: "Fire",
    },
    {
      symbol: "♑",
      name: "Capricorn",
      date: "",
      element: "Earth",
    },
    { symbol: "♒", name: "Aquarius", date: "", element: "Air" },
    { symbol: "♓", name: "Pisces", date: "", element: "Water" },
  ];

  const [selectedTopic, setSelectedTopic] = useState(zodiacList[0].name);
  const [selectedTopic1, setSelectedTopic1] = useState("Weekly");
  const [selectedZodiac, setSelectedZodiac] = useState(zodiacList[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [apidata, setsetapidata] = useState("");
  const [displayDate, setDisplayDate] = useState("");

  const handelapihit = async (selecteddata) => {
    setIsLoading(true);
    setsetapidata("");
    const formData = new FormData();
    formData.append("sign", selectedTopic);
    formData.append("day", selecteddata);
    await server_post_data(get_daily_prediction, formData)
      .then((Response) => {
        setsetapidata(Response.data.horoscope_data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const formatDate = (date, options) =>
    date.toLocaleDateString("en-US", options);
  const updateDisplayDate = (period) => {
    const today = new Date();

    if (period === "Daily") {
      setDisplayDate(
        formatDate(today, {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      );
    } else if (period === "Weekly") {
      const start = new Date(today);
      const end = new Date(today);

      // Set start to Sunday, end to Saturday
      const dayOfWeek = today.getDay(); // 0 (Sun) to 6 (Sat)
      start.setDate(today.getDate() - dayOfWeek);
      end.setDate(today.getDate() + (6 - dayOfWeek));

      const startFormatted = formatDate(start, {
        weekday: "short",
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      const endFormatted = formatDate(end, {
        weekday: "short",
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      setDisplayDate(`${startFormatted} - ${endFormatted}`);
    } else if (period === "Monthly") {
      setDisplayDate(
        formatDate(today, {
          month: "long",
          year: "numeric",
        })
      );
    }
  };

  useEffect(() => {
    updateDisplayDate(selectedTopic1);
  }, [selectedTopic1]);
  useEffect(() => {
    if (selectedTopic !== "Select Topic" && selectedTopic1 !== "Select Topic") {
      handelapihit(selectedTopic1);
    }
  }, [selectedTopic, selectedTopic1]);
  return (
    <>
      <Header />
      {isLoading && <Loader />}
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-[1250px] mx-auto py-10 px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4">
              🔮 Daily Predictions (Rashi Phal)
            </h2>
            <p className="text-lg text-purple-300">
              Discover what the stars have in store for you today
            </p>
          </div>

          {/* Zodiac Buttons */}
          <div className="flex overflow-x-auto scrollbar gap-3 mb-8 py-2 px-1">
            {zodiacList.map((sign, i) => (
              <button
                key={i}
                onClick={() => {
                  setSelectedZodiac(sign);
                  setSelectedTopic(sign.name);
                }}
                className={`flex-shrink-0 justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium p-4 h-auto flex flex-col items-center space-y-1 transition-all duration-300 cursor-pointer backdrop-blur-sm 
        ${
          selectedZodiac.name === sign.name
            ? "bg-purple-600 hover:bg-purple-700 text-white"
            : "bg-slate-800/50 border-purple-500/30 text-white hover:bg-purple-800/50 border"
        }`}
              >
                <div className="text-2xl">{sign.symbol}</div>
                <div className="text-[17px] font-medium">{sign.name}</div>
                <div className="text-[11px] font-medium">{displayDate}</div>
                <div className="text-[11px] font-medium px-[12px] py-[5px] bg-purple-600/20 text-white border border-white rounded-full">
                  {sign.element} Element
                </div>
              </button>
            ))}
          </div>

          {/* Selected Zodiac Info */}
          {/* <div className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/50 border-purple-500/20 backdrop-blur-sm mb-8">
            <div className="flex flex-col space-y-1.5 p-6 text-center">
              <div className="flex items-center justify-center space-x-4 mb-2">
                <div className="text-6xl">{selectedZodiac.symbol}</div>
                <div>
                  <h3 className="font-semibold tracking-tight text-3xl text-purple-100">
                    {selectedZodiac.name}
                  </h3>
                  <p className="text-sm text-purple-300">{displayDate}</p>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-purple-600/20 text-purple-300 border-purple-500/30 mt-2">
                    {selectedZodiac.element} Element
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* Tabs */}
          <div className="w-full">
            <div className="h-10 grid grid-cols-3 items-center justify-center rounded-md p-1 bg-slate-800/50 border border-purple-500/20">
              {[
                { key: "TODAY", label: "📅 Daily" },
                { key: "Weekly", label: "🗓️ Weekly" },
                { key: "Monthly", label: "📆 Monthly" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setSelectedTopic1(tab.key)}
                  className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ${
                    selectedTopic1 === tab.key
                      ? "bg-purple-600 text-white shadow-sm"
                      : "text-purple-300"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab content */}
            <div className="mt-6">
              {!apidata || apidata === "" || apidata === "0" ? (
                <div className="text-center text-white">No data available.</div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    margin: "0 auto",
                    padding: "0px",
                    overflowY: "auto",

                    boxSizing: "border-box",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `
        
          <style>
        
            .content {
              background: transparent;
              padding: 20px;
              border-radius: 8px;
              border:1px solid #dee2e6;
              font-size: 16px;
              text-align: justify;
              border-left: 4px solid #dee2e6;
              color: #fff;
            }
            .content::first-letter {
              font-size: 2.5em;
              font-weight: bold;
              float: left;
              line-height: 1;
              margin: 0 8px 0 0;
              color: #667eea;
            }
            p {
              margin-bottom: 12px;
            }
          </style>
          <div class="content">
            ${DOMPurify.sanitize(apidata || "")}
          </div>
        `,
                  }}
                />
              )}

              {/* Bottom Info Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 hidden">
                <div className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/30 border-purple-500/20 p-6 text-center">
                  <div className="text-4xl mb-3">🌙</div>
                  <h3 className="text-lg font-semibold text-purple-200 mb-2">
                    Moon Phase
                  </h3>
                  <p className="text-purple-300 text-sm">
                    Waxing Crescent - New beginnings
                  </p>
                </div>
                <div className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/30 border-purple-500/20 p-6 text-center">
                  <div className="text-4xl mb-3">⭐</div>
                  <h3 className="text-lg font-semibold text-purple-200 mb-2">
                    Lucky Number
                  </h3>
                  <p className="text-purple-300 text-sm">7</p>
                </div>
                <div className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/30 border-purple-500/20 p-6 text-center">
                  <div className="text-4xl mb-3">🎨</div>
                  <h3 className="text-lg font-semibold text-purple-200 mb-2">
                    Lucky Color
                  </h3>
                  <p className="text-purple-300 text-sm">Purple & Gold</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
